/* GENERATED FILE */
import type { ReactElement, FC } from 'react';
import { Path } from 'react-native-svg';
import { type IconWeight } from '../lib';

export default new Map<
  IconWeight,
  ReactElement | FC<{ duotoneColor?: string; duotoneOpacity?: number }>
>([
  [
    'bold',
    <>
      <Path d="M180 72.28V72a20 20 0 0 0-20-20h-20V16a12 12 0 0 0-24 0v36H96a20 20 0 0 0-20 20v.28A115.7 115.7 0 0 0 12 176a12 12 0 0 0 12 12h60.19a44 44 0 0 0 87.62 0H232a12 12 0 0 0 12-12 115.7 115.7 0 0 0-64-103.72M128 204a20 20 0 0 1-19.6-16h39.2a20 20 0 0 1-19.6 16m-91.22-40a91.75 91.75 0 0 1 55.84-72.95A12 12 0 0 0 100 80v-4h56v4a12 12 0 0 0 7.38 11.08 91.75 91.75 0 0 1 55.84 73Z" />
    </>,
  ],
  [
    'duotone',
    ({
      duotoneColor,
      duotoneOpacity,
    }: {
      duotoneColor?: string;
      duotoneOpacity?: number;
    }) => (
      <>
        <Path
          d="M232 176H24a104 104 0 0 1 64-96v-8a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8v8a104 104 0 0 1 64 96"
          opacity={duotoneOpacity}
          fill={duotoneColor}
        />
        <Path d="M176 74.78V72a16 16 0 0 0-16-16h-24V16a8 8 0 0 0-16 0v40H96a16 16 0 0 0-16 16v2.78A111.73 111.73 0 0 0 16 176a8 8 0 0 0 8 8h64a40 40 0 0 0 80 0h64a8 8 0 0 0 8-8 111.73 111.73 0 0 0-64-101.22M128 208a24 24 0 0 1-24-24h48a24 24 0 0 1-24 24m-95.67-40a95.79 95.79 0 0 1 58.75-80.65A8 8 0 0 0 96 80v-8h64v8a8 8 0 0 0 4.92 7.38A95.79 95.79 0 0 1 223.67 168Z" />
      </>
    ),
  ],
  [
    'fill',
    <>
      <Path d="M176 74.78V72a16 16 0 0 0-16-16h-24V16a8 8 0 0 0-16 0v40H96a16 16 0 0 0-16 16v2.78A111.73 111.73 0 0 0 16 176a8 8 0 0 0 8 8h64a40 40 0 0 0 80 0h64a8 8 0 0 0 8-8 111.73 111.73 0 0 0-64-101.22M128 208a24 24 0 0 1-24-24h48a24 24 0 0 1-24 24" />
    </>,
  ],
  [
    'light',
    <>
      <Path d="M174 76.05V72a14 14 0 0 0-14-14h-26V16a6 6 0 0 0-12 0v42H96a14 14 0 0 0-14 14v4a109.76 109.76 0 0 0-64 100 6 6 0 0 0 6 6h66v2a38 38 0 0 0 76 0v-2h66a6 6 0 0 0 6-6 109.76 109.76 0 0 0-64-99.95M154 184a26 26 0 0 1-52 0v-2h52ZM30.18 170a97.76 97.76 0 0 1 60.13-84.49A6 6 0 0 0 94 80v-8a2 2 0 0 1 2-2h64a2 2 0 0 1 2 2v8a6 6 0 0 0 3.69 5.54A97.76 97.76 0 0 1 225.82 170Z" />
    </>,
  ],
  [
    'regular',
    <>
      <Path d="M176 74.78V72a16 16 0 0 0-16-16h-24V16a8 8 0 0 0-16 0v40H96a16 16 0 0 0-16 16v2.78A111.73 111.73 0 0 0 16 176a8 8 0 0 0 8 8h64a40 40 0 0 0 80 0h64a8 8 0 0 0 8-8 111.73 111.73 0 0 0-64-101.22M128 208a24 24 0 0 1-24-24h48a24 24 0 0 1-24 24m-95.67-40a95.79 95.79 0 0 1 58.75-80.65A8 8 0 0 0 96 80v-8h64v8a8 8 0 0 0 4.92 7.38A95.79 95.79 0 0 1 223.67 168Z" />
    </>,
  ],
  [
    'thin',
    <>
      <Path d="M172 77.34V72a12 12 0 0 0-12-12h-28V16a4 4 0 0 0-8 0v44H96a12 12 0 0 0-12 12v5.34A107.75 107.75 0 0 0 20 176a4 4 0 0 0 4 4h68v4a36 36 0 0 0 72 0v-4h68a4 4 0 0 0 4-4 107.75 107.75 0 0 0-64-98.66M156 184a28 28 0 0 1-56 0v-4h56ZM28.08 172a99.77 99.77 0 0 1 61.46-88.34A4 4 0 0 0 92 80v-8a4 4 0 0 1 4-4h64a4 4 0 0 1 4 4v8a4 4 0 0 0 2.46 3.69A99.77 99.77 0 0 1 227.92 172Z" />
    </>,
  ],
]);
